
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as HugeGroupIconComponent } from "./huge-group-icon.svg";

export const HugeGroupIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <HugeGroupIconComponent {...props} />;
};
